import { useConfirm } from '@components/Confirm'
import useNotify from '@containers/@modules/Notification/useNotify'
import useAuth from '@utils/hooks/useAuth'
import useFirebaseListener from '@utils/hooks/useFirebaseListener'
import useInit from '@utils/hooks/useInit'
import _ from 'lodash'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const RealTimeInjector: React.FC = () => {
  const { initApp: app, notifications, company_switch } = useFirebaseListener()
  const { initApp, baseURL, initData } = useInit()
  const { isLoggedIn } = useAuth()
  const { fetchCount } = useNotify()
  const { t } = useTranslation()
  const companies = _.get(initData, 'attributes.companies.data', [])
  // lodash find to      "company_type": "main"
  const current = _.find(
    companies,
    (companies) => companies.attributes.company_type === 'main'
  )?.attributes.company.data.attributes.uid

  const confirm = useConfirm()

  useEffect(() => {
    if (!_.isEmpty(baseURL) && isLoggedIn) {
      initApp()
      // eslint-disable-next-line no-console
      console.info(
        '%cSyncing common data',
        'color: white; font-size: 12px; background:green; padding:5px;',
        'id:',
        app
      )
    }
  }, [isLoggedIn, baseURL, app])

  useEffect(() => {
    if (notifications) {
      fetchCount()
      //fetch notification
      // eslint-disable-next-line no-console
      console.info(
        '%cSyncing notification',
        'color: white; font-size: 12px; background:blue; padding:5px;',
        'id:',
        notifications
      )
    }
  }, [notifications])

  useEffect(() => {
    let showAlert: any
    if (company_switch && company_switch !== null && current) {
      if (company_switch !== current) {
        // trigger confirm after 3 sec
        showAlert = setTimeout(() => {
          confirm({
            title: t('SYSCOMMON.title'),
            description: t('SYSCOMMON.alert_description'),
            sweet_alert: 'success',
          })
            .then(() => {
              window.location.reload()
            })
            .catch(() => null)
        }, 3000)
      }

      // clear time out
      // eslint-disable-next-line no-console
      console.info(
        '%cCompany swith',
        'color: white; font-size: 12px; background:blue; padding:5px;',
        'id:',
        company_switch
      )

      return () => showAlert && clearTimeout(showAlert)
    }
  }, [company_switch, current])

  // This component doesn't render anything visible
  return null
}

export default RealTimeInjector
